import React from 'react';
import { Box, IconButton, Chip, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';

export default function ApiKeyTable({ apiKeys = [], onRevoke }) {
  const columns = [
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'key', headerName: 'Key', flex: 1.5, renderCell: (p) => (
      <code style={{ fontSize: 12 }}>{p.value ? `${String(p.value).slice(0, 12)}...` : '—'}</code>
    )},
    { field: 'status', headerName: 'Status', width: 120, renderCell: (p) => (
      <Chip label={p.value || 'active'} color={p.value === 'revoked' ? 'error' : 'success'} size="small" />
    )},
    { field: 'createdAt', headerName: 'Created', width: 160, valueFormatter: (p) => p.value ? new Date(p.value).toLocaleDateString() : '—' },
    { field: 'actions', headerName: 'Actions', width: 100, sortable: false, renderCell: (p) => (
      <Tooltip title="Revoke">
        <IconButton size="small" color="error" onClick={() => onRevoke?.(p.row?.id)} disabled={p.row?.status === 'revoked'}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )}
  ];

  return (
    <Box sx={{ height: 500, width: '100%' }}>
      <DataGrid
        rows={apiKeys}
        columns={columns}
        getRowId={(row) => row.id || row.key || Math.random()}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
      />
    </Box>
  );
}
